// AUTO-GENERATED FILE - DO NOT EDIT
import * as z from "zod";
import { requestHandler } from "../requestHandler";

export const path = "update-invoice-state";

export const updateInvoiceStateParamsSchema = z.object({
  invoiceId: z.string().uuid(),
  state: z.enum(["Pending", "Paid", "Overdue"]),
});




export type UpdateInvoiceStateParams = z.infer<
  typeof updateInvoiceStateParamsSchema
>;




// broker/update-invoice-state endpoint
export function updateInvoiceState(
  params: z.input<typeof updateInvoiceStateParamsSchema>
): Promise<void> {
  return requestHandler(
    "broker/update-invoice-state",
    params,
    undefined,
  );
}

